import { useRouterState } from "@tanstack/react-router";

import { BrandLogo } from "@/components/site/BrandLogo";
import { localeFromPath } from "@/lib/i18n/I18nProvider";

const NOT_FOUND_COPY = {
  en: {
    heading: "Page not found",
    body: "The page you're looking for doesn't exist or has been moved.",
    cta: "Go home",
    home: "/",
  },
  bg: {
    heading: "Страницата не е намерена",
    body: "Страницата, която търсите, не съществува или е преместена.",
    cta: "Към началото",
    home: "/bg",
  },
} as const;

export function NotFoundPage() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const locale = localeFromPath(pathname);
  const copy = NOT_FOUND_COPY[locale];
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <div className="mb-8 flex justify-center">
          <BrandLogo size={28} />
        </div>
        <h1 className="text-7xl font-bold text-foreground">404</h1>
        <h2 className="mt-4 text-xl font-semibold text-foreground">{copy.heading}</h2>
        <p className="mt-2 text-sm text-muted-foreground">{copy.body}</p>
        <div className="mt-6">
          <a
            href={copy.home}
            className="inline-flex h-10 items-center justify-center rounded-[8px] bg-primary px-5 text-[13px] font-semibold text-primary-foreground transition-colors hover:bg-primary/90"
          >
            {copy.cta}
          </a>
        </div>
      </div>
    </div>
  );
}
